<template>
	<div>
		<div class="list-area">
			<div class="pb-2">
				{{ getStateWithParam("volunteering_topic_application_label") }}
			</div>

			<div
				class="pb-2 no-application"
				v-if="getUnconfirmedApplications.length == 0"
			>
				{{
					getStateWithParam("volunteering_topic_no_application_label")
				}}
			</div>

			<v-flex>
				<v-card
					v-for="(application, index) in getUnconfirmedApplications"
					:key="index"
					class="application-card d-flex justify-space-between"
				>
					<div class="card-content">
						<div class="card-title">
							<span class="bolded-text">
								{{ application.firstName }}
								{{ application.lastName }}
							</span>
						</div>
						<div class="card-subtitle">
							<span class="bolded-text">
								{{
									getStateWithParam(
										"volunteering_form_email"
									)
								}}:
							</span>
							{{ application.email }}
						</div>
						<!-- <div class="card-subtitle">
										<span class="bolded-text">
											{{
												getStateWithParam(
													"volunteering_form_number"
												)
											}}:
										</span>
										{{ application.phoneNumber }}
									</div> -->
						<!-- <div class="card-subtitle">
										<span class="bolded-text">
											{{
												getStateWithParam(
													"volunteering_form_birthday"
												)
											}}:
										</span>
										{{ application.birthday }}
									</div> -->
						<!-- <div class="card-subtitle">
										<span class="bolded-text">
											{{
												getStateWithParam(
													"volunteering_form_project_name"
												)
											}}:
										</span>
										{{ application.volunteeringProject }}
									</div> -->
						<!-- <div class="card-subtitle">
										<span class="bolded-text">
											{{
												getStateWithParam(
													"volunteering_form_commitment_name"
												)
											}}:
										</span>
										{{
											application.interests.id.join(
												", "
											)
										}}
									</div> -->
					</div>

					<div class="card-actions">
						<button
							class="delete-button"
							@click="openDialog(index)"
						>
							Finish
						</button>
					</div>
				</v-card>
			</v-flex>
		</div>

		<v-dialog
			v-if="codeOpen"
			v-model="codeOpen"
			@click:outside="codeOpen = false"
		>
			<v-card>
				<v-card-title class="text-h5 grey lighten-2">
					{{ getStateWithParam("volunteering_confirmation_title") }}
				</v-card-title>

				<v-card-text>
					{{
						getStateWithParam("volunteering_confirmation_text")
					}}</v-card-text
				>

				<v-card-text class="email-code">
					{{
						getUnconfirmedApplications[dialogIndex].email
					}}</v-card-text
				>

				<v-card-text
					class="email-code-resend"
					@click="submitForm(dialogIndex)"
				>
					{{ getStateWithParam("volunteering_resend_code_text") }}
				</v-card-text>

				<div class="input-code">
					<input
						v-model="code"
						type="number"
						:placeholder="
							getStateWithParam('volunteering_confirmation_label')
						"
						required
						oninput="this.value = this.value.slice(0, 6)"
						@input="validateCode"
					/>
					<label v-if="codeError" class="error-label">{{
						codeError
					}}</label>
					<label v-if="kodigabim" class="error-label">{{
						kodigabimerror
					}}</label>
				</div>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn
						class="back-button"
						color="primary"
						text
						@click="
							sendCode(
								getUnconfirmedApplications[dialogIndex].email,
								code,
								dialogIndex
							)
						"
					>
						{{
							getStateWithParam(
								"volunteering_confirmation_submit_button"
							)
						}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-if="submitted && !applicationError && !codeOpen"
			v-model="submitted"
		>
			<v-card>
				<v-card-title class="text-h5 grey lighten-2">
					{{
						getStateWithParam(
							"volunteering_form_toast_success_title"
						)
					}}
				</v-card-title>

				<v-card-text>
					{{
						getStateWithParam(
							"volunteering_form_toast_success_text"
						)
					}}</v-card-text
				>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						class="back-button"
						color="primary"
						text
						@click="(submitted = false), (code = '')"
					>
						{{
							getStateWithParam(
								"volunteering_form_toast_back_button_all"
							)
						}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-if="submitted && applicationError && !codeOpen"
			v-model="submitted"
		>
			<v-card>
				<v-card-title class="text-h5 grey lighten-2">
					{{
						getStateWithParam(
							"volunteering_form_toast_failed_title"
						)
					}}
				</v-card-title>

				<v-card-text>
					{{
						getStateWithParam("volunteering_form_toast_failed_text")
					}}
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						class="back-button"
						color="primary"
						text
						@click="submitted = false"
					>
						{{
							getStateWithParam(
								"volunteering_form_toast_back_button"
							)
						}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import native_capacitor from "@/config/js_helper/native_capacitor.js";
import { mapGetters } from "vuex";
import {
	VOLUNTEERING_FORM_URL_TOPIC,
	VOLUNTEERING_FORM_URL_VERIFY,
} from "@/config/api/url/urls_in_app";
import {
	API_CLIENT_POST_FORM,
	API_CLIENT_GET,
} from "@/config/api/api_call/service_instances";

export default {
	name: "volunteeringApplicationsTopic",

	data() {
		return {
			kodigabim: false,
			submitted: false,
			applicationError: false,
			codeOpen: false,
			code: "",
			codeError: "",
			kodigabimerror: "",
			dataloaded: false,
			errorloading: false,
			applications: [],
			dialog: false,
			dialogIndex: null,

			verificationFormdata: {
				deviceId: "",
				email: "",
				verificationCode: "",
			},
		};
	},
	created() {
		this.getApplications();
		native_capacitor.getPhoneId().then((userid) => {
			this.verificationFormdata.deviceId = userid.uuid;
		});
	},
	computed: {
		...mapGetters([
			"getLanguageParameters",
			"getUnconfirmedApplications",
			,
		]),
	},
	methods: {
		getApplications() {
			this.$store
				.dispatch("initializeUnconfirmedApplications")
				.then((response) => {
					this.applications = response;
					this.dataloaded = true;
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.errorloading = true;
					this.$store.state.active_loader = false;
				});
		},
		deleteApplication(index) {
			const application = this.getUnconfirmedApplications[index];
			this.$store.dispatch(
				"removeUnconfirmedApplication",
				application.email
			);
			this.dialog = false;
		},

		submitForm(index) {
			const application = this.getUnconfirmedApplications[index];

			this.$store.state.active_loader = true;

			API_CLIENT_POST_FORM(VOLUNTEERING_FORM_URL_TOPIC, application)
				.then((response) => {
					// this.submitted = true;

					this.applicationError = false;
					this.$store.dispatch(
						"addUnconfirmedApplication",
						application
					);
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.$store.state.active_loader = false;
					console.log(err);

					// this.submitted = true;
					this.applicationError = true;
				});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		openDialog(index) {
			this.codeOpen = true;
			this.dialogIndex = index; // Store the index for dialog
		},

		validateCode() {
			if (this.code.length === 6) {
				this.codeError = "";
			} else {
				this.codeError = this.getStateWithParam(
					"volunteering_form_valid_code_rule"
				);
			}
		},
		sendCode(email, code, dialogIndex) {
			if (this.code.length === 6) {
				// Perform your logic here
				this.verificationFormdata.email = email;
				this.verificationFormdata.verificationCode = code;
				this.$store.state.active_loader = true;
				API_CLIENT_POST_FORM(
					VOLUNTEERING_FORM_URL_VERIFY,
					this.verificationFormdata
				)
					.then((response) => {
						this.deleteApplication(dialogIndex);
						this.codeOpen = false;
						this.submitted = true;
						this.applicationError = false;
						this.$store.state.active_loader = false;
					})
					.catch((err) => {
						this.$store.state.active_loader = false;
						console.log(err);

						this.submitted = true;
						this.applicationError = true;
						this.kodigabim = true;
						this.kodigabimerror = this.getStateWithParam(
							"volunteering_form_valid_code_not_confirmed"
						);
					});

				console.log(this.verificationFormdata);
			} else {
				this.codeError = this.getStateWithParam(
					"volunteering_form_valid_code_rule"
				);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.application-card {
	background-color: #ffffff;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	border-radius: 8px;
	padding: 16px;
	margin-bottom: 16px;
	transition: box-shadow 0.3s ease;
	position: relative;
}

.application-card:hover {
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-content {
	flex-grow: 1;
}

.bolded-text {
	font-weight: bold;
}
.no-application {
	color: #b6b6b6;
}

.card-title {
	font-size: 18px;
	margin-bottom: 8px;
}

.card-subtitle {
	margin-bottom: 8px;
}

.card-actions {
	position: absolute;
	bottom: 25px;
	right: 8px;
}

.delete-button {
	background-color: #f74c4c;
	color: #fff;
	padding: 8px 12px;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.delete-button v-icon {
	vertical-align: middle;
}
</style>
